import { SectionIds } from "./sectionIds";

export const navLinks = [
  {
    label: "About our system",
    tKey: "common:navLabels.aboutOurSystem",
    sectionID: SectionIds.SystemSkeyTix,
    offsetTopDesktop: 0,
    offsetTopMobile: 0
  },
  {
    label: "Advantages",
    tKey: "common:navLabels.advantages",
    sectionID: SectionIds.SystemAdvantages,
    offsetTopDesktop: 0,
    offsetTopMobile: 0
  },
  {
    label: "API",
    tKey: "common:navLabels.api",
    sectionID: SectionIds.ApiIntegration,
    offsetTopDesktop: 0,
    offsetTopMobile: 0
  },
  {
    label: "POAP",
    tKey: "common:navLabels.poap",
    sectionID: SectionIds.SkeyPoap,
    offsetTopDesktop: 0,
    offsetTopMobile: 0
  },
  {
    label: "Contact",
    tKey: "common:navLabels.contact",
    sectionID: SectionIds.Footer,
    offsetTopDesktop: 0,
    offsetTopMobile: 0
  }
];
